/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-03-07 17:09:25
 * @LastEditTime: 2025-08-19 10:15:13
 * @LastEditors: ywj@originqc.com
 */
import React, { useEffect, useState } from "react";
import { useAppSelector } from '@/redux/hooks';
import { useNavigate } from "react-router-dom";
import { Button, Modal, message, Spin } from "antd";
import CarouselComponent from '@/components/like-carousel';
import { orderCountTotal, getOrderList, confirmReceipt } from '@/api/personal-center';
import NoData from '@/components/no-data';
import faceImg from '../assets/default-face.png';
import {getBuyNumber} from '@/utils'
import './index.scss';

function Personal() {
  const { userInfo } = useAppSelector(state => state.user);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [sureOpen,setSureOpen] = useState(false); // 确认收货
  const [orderStatus, setOrderStatus] = useState<any>({}); // 订单状态
  const [pageNum, setPageNum] = useState(1); // 表格页码
  const [hasMore, setHasMore] = useState(false);
  const [pendData, setPendData] = useState<any>([]); // 待收货数据
  const [orderId, setOrderId] = useState(''); // 订单id
  const pageSize = 10;

  useEffect(() => {
    orderCountFunc();
  },[])
  useEffect(() => {
    orderListFunc();
  },[pageNum])
  // 确认收货弹窗
  const sureTakeGoods = (id:string) => {
    setOrderId(id);
    setSureOpen(true);
  }
  // 确认收货
  const confirmReceiptFunc = () => {
    confirmReceipt(orderId).then((cRes:any) => {
      if(cRes.success) {
        setPendData([]);
        setPageNum(1);
        setSureOpen(false);
        orderListFunc();
        const contentElement = document.querySelector('.dynamics-list-content');
        if(contentElement) {
          contentElement.scrollTop = 0;
        }
      }else {
        message.error(cRes.message);
      }
    })
  }
  // 订单状态统计
  const orderCountFunc = () => {
    orderCountTotal().then((oData:any) => {
      if(oData.success) {
        setOrderStatus(oData.obj);
      }
    })
  }
   // 获取订单列表
   const orderListFunc = () => {
    setLoading(true);
    const params = {
      status: 2,
      isDyna: 1,
      pageNum,
      pageSize
    }
    // 这里应该是你的数据获取逻辑
    setTimeout(() => {
      getOrderList(params).then((gRes:any) => {
        if(gRes.success) {
          setPendData((prevData:any) => [...prevData, ...gRes.obj.list]);
          setHasMore(gRes.obj.hasNextPage);
          setLoading(false);
        }else {
          message.error(gRes.message);
        }
      })
    }, 1000);
   
  }
  useEffect(() => {
    const tableBody = document.querySelector('.dynamics-list-content');
    if (tableBody) {
      const handleScroll = () => {
        const { scrollTop, scrollHeight, clientHeight } = tableBody;
        if (scrollHeight - scrollTop === clientHeight && hasMore) {
          // 当滚动到底部时加载更多数据
          setPageNum(pageNum+1);
        }
      };
 
      tableBody.addEventListener('scroll', handleScroll);
 
      return () => {
        tableBody.removeEventListener('scroll', handleScroll);
      };
    }
  }, [hasMore]);
  const gotoOrder = (index:number) => {
    navigate(`/user/orderList/${index}`);
  }
  return (
    <div className="personal-main">
      <div className="personal-order-content">
        <div className="center-show">
          <img src={userInfo.face??faceImg} alt='' onClick={()=>window.location.href='https://account.originqc.com.cn/'} />
          <div className="area-default">
            <h1><span onClick={()=>window.location.href='https://account.originqc.com.cn/'}>{userInfo.name}</span></h1>
            <h2>默认收货地址：</h2>
            <h2>{orderStatus.address?.province} {orderStatus.address?.city} {orderStatus.address?.region} {orderStatus.address?.detailAddress}</h2>
          </div>
          <Button onClick={()=>navigate('/user/coupon')}>优惠券：{orderStatus.couponNum}</Button>
        </div>
        <div className="goods-situation">
          <div className="situation-list" onClick={()=>gotoOrder(0)}>
            <span>{orderStatus.unpaid}</span>
            <span>待付款</span>
          </div>
          <div className="situation-list" onClick={()=>gotoOrder(6)}>
            <span>{orderStatus.audit}</span>
            <span>付款审核</span>
          </div>
          <div className="situation-list" onClick={()=>gotoOrder(9)}>
            <span>{orderStatus.unReceive}</span>
            <span>待收货</span>
          </div>
          <div className="situation-list" onClick={()=>navigate('/user/as/List')}>
            <span>{orderStatus.apply}</span>
            <span>售后申请</span>
          </div>
        </div>

      </div>
      <div className="dynamics-content">
        <div className="order-dynamics">
          <>
            <div className="dynamics-title">
              订单动态
              <span onClick={()=> navigate('/user/orderList')}>全部订单 &gt;</span>
            </div>
            {
              pendData.length > 0 ?
              <ul className="dynamics-list-content">
                {
                  pendData.map((pData:any) => (
                    <li key={pData.id}>
                      {
                        pData.logisticVO?.routes?.length > 0 &&
                        <p>{pData.logisticVO?.routes[0].time}&nbsp;&nbsp;{pData.logisticVO?.routes[0].status}&nbsp;&nbsp;{pData.logisticVO?.routes[0].remark}</p>
                      }
                      {
                        pData.productList?.length > 0 &&
                        <>
                        {
                          pData.productList.map((pEle:any,index:number) => (
                            <div className="order-info-list" key={pEle.id}>
                              <div className="order-goods">
                                <img onClick={()=>navigate(`/user/order/detail/${pData.id}`)} src={pEle.pmsFiles[0]?.url} alt='' />
                                <div className="order-info">
                                  <h2 onClick={() => navigate(`/user/order/detail/${pData.id}`)}
                                    // title={pEle.productName + ' ' + (pEle.models.find((ele: any) => ele?.type === 1))?.models}
                                    title={pEle.productName + ' ' + (pEle.models.find((ele: any) => ele?.type === 1))?.models + ' ' + (pEle.models.find((ele: any) => ele?.feeType === '2') ? getBuyNumber((pEle.models.find((ele: any) => ele?.type === 1))?.subscribe[0]?.unit,pEle?.productQuantity) : '')}
                                  ><span>{pEle.productName}</span>
                                    {
                                      pEle.models.length > 0 &&
                                      <>
                                      {(pEle.models.find((ele:any)=>ele?.type===1))?.models} {pEle.models.find((ele:any)=>ele?.feeType==='2')&&getBuyNumber((pEle.models.find((ele:any)=>ele?.type===1))?.subscribe[0]?.unit,pEle?.productQuantity)}
                                      </>
                                    }
                                  </h2>
                                  <h3>{pData.logisticVO?.name}&nbsp;&nbsp;{pData.logisticVO?.mailNo}</h3>
                                  {
                                    Object.keys(pData?.activation ?? {}).length > 0 ? <div className="order-activation">
                                     { pData?.activation?.status === 1 ? '商品已激活' : '商品未激活'}
                                    </div> : <></>
                                  }
                                  
                                </div>
                              
                              </div>
                              {
                                index === 0 && 
                                <span onClick={()=>sureTakeGoods(pData.id)} className="sure-delivery">确认收货</span>
                              }
                            </div>
                          ))
                        }
                        </>
                      }
                     
                    </li>
                  ))
                }
               {loading && <Spin style={{ textAlign: 'center', margin: '16px 0' }} />}
              </ul>:
              <NoData title={`暂无订单动态  <a href='/home'>去首页</a> 浏览商品`} />
            }
          </>
        </div>
        <div className="like-recommend">
          <CarouselComponent mode='mini' showCount={2} />
        </div>
      </div>
      <Modal
        title="确认收货"
        open={sureOpen}
        onCancel={()=>setSureOpen(false)}
        className="goods-dialog-main"
        footer={false}
        width={450}
      >
        <p>请您确认是否收到货物？</p>
        <div className="dialog-bottom">
          <Button className="submit-info" onClick={()=>confirmReceiptFunc()}>是</Button>
          <Button onClick={()=>setSureOpen(false)}>否</Button>
        </div>
      </Modal>
    </div>
  )
}

export default Personal;
